// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'

// Overwrite stylus of vuetify
import './stylus/main.styl';

// Sync router with store
import { sync } from 'vuex-router-sync'

// Vue FullPage.js Scroll
import VueFullPage from 'vue-fullpage.js'
Vue.use(VueFullPage)

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'

// Sync store with router
sync(store, router)

window.$ = require('jquery')
window.jQuery = require('jquery')
window.velocity = require('velocity-animate')

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

import _ from 'lodash'
Vue.use(_)

// Kinesis
import VueKinesis from 'vue-kinesis'
Vue.use(VueKinesis)

// import VueScrollProgress from 'vue-scroll-progress'
// Vue.use(VueScrollProgress)

import VueMouseParallax from 'vue-mouse-parallax'
Vue.use(VueMouseParallax)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    preLoad: 0.5,
    error: '/img/error-404.svg',
    loading: '/img/Ripple-50px.svg',
    attempt: 2
  })
  
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')